export interface DirectorList {
  DirectorIdentification?: string;
  DirectorTitle?: string;
  DirectorFullName?: string;
  DirectorPosition?: string;
}

export interface AuthorizedDirector {
  AuthorIdentification?: string;
  AuthorTitle?: string;
  AuthorFullName?: string;
  AuthorPosition?: string;
  AuthorType?: string;
}
export interface ServiceAndItem {
  ServiceItemType?: string;
  ServiceItemID?: string;
  OtherService?: string;
}

export interface FormRegister {
  SellerStatus: string;
  SellerType?: string;
  SellerNameTh: string;
  SellerNameEn?: string;
  SellerRegisterType: string;
  MobilePhone: string;
  IdentificationNo: string;
  DateOfRegisteration: string;
  NumberOfShares: number;
  RegisteredCapital: number;
  ListOfDirector: DirectorList[];
  ListAuthorizedDirectors: AuthorizedDirector[];
  BussniesType: string;
  TaxpayerIdentificationNo: string;
  Region: string;
  Buildings: string;
  Room: string;
  Floor: string;
  Village: string;
  HouseNo: string;
  Swine: string;
  Alley: string;
  Road: string;
  Province: string;
  State: string;
  Districe: string;
  Post: string;
  ContactName: string;
  PhoneNumber: string;
  Per: string;
  Email: string;
  DigitalContact: string;
  CertificateOfRegisteration?: string[];
  ExceptionDetail?: string[];
  Certificate?: string[];
  CertOfCompletion?: string[];
  ServiceAndItem?: ServiceAndItem[];
  OtherService?: string;
  LogoPath?: string[];
  CatalogFilePath?: string[];
  deliveryDate?: { capital?: number; provincial?: number };
}

export interface Files {
  name: string;
  file: File | undefined;
}

export interface FIleUpload {
  CertificateOfRegisteration: Files[];
  ExceptionDetail: Files[];
  Certificate: Files[];
  CertOfCompletion: Files[];
  LogoPath: Files[];
  CatalogFilePath: Files[];
}

export interface Errors {
  type: string;
  message: string;
}

export interface ErrosFIleUpload {
  CertificateOfRegisteration: Errors[];
  ExceptionDetail: Errors[];
  Certificate: Errors[];
  CertOfCompletion: Errors[];
  LogoPath: Errors[];
  CatalogFilePath: Errors[];
}

export const initialFile = <T>(): T => {
  return {
    CertificateOfRegisteration: [],
    ExceptionDetail: [],
    Certificate: [],
    CertOfCompletion: [],
    LogoPath: [],
    CatalogFilePath: [],
  } as T;
};

export const initialDirector: DirectorList[] = [
  {
    DirectorPosition: undefined,
    DirectorTitle: undefined,
    DirectorFullName: undefined,
    DirectorIdentification: undefined,
  },
];

export const initialAuthorizedDirector: AuthorizedDirector[] = [
  {
    AuthorPosition: undefined,
    AuthorTitle: undefined,
    AuthorFullName: undefined,
    AuthorIdentification: undefined,
    AuthorType: undefined,
  },
];

export const initialServiceAndItem: ServiceAndItem[] = [
  {
    ServiceItemType: undefined,
    ServiceItemID: undefined,
  },
];

export const initialFileUpload = initialFile<FIleUpload>();

export const initailErrors = initialFile<ErrosFIleUpload>();

export interface BlacklistItem {
  blackListID: number;
  blackListIdentification: string;
  blackListTitleName: string;
  blackListFullName: string;
  businessType: string;
  excutivePosition: string;
  isActive: boolean;
  createdBy: string;
  createdDate: Date;
  modifiedBy: string;
  modifiedDate: Date;
}

export interface ResponseDataBalckList {
  isSuccess: boolean;
  supplierType: string;
  position: string;
  blacklist: BlacklistItem[];
}

export interface SubmitResponse {
  data: ResponseDataBalckList | null;
  message: string;
  code: string;
}
